import React, { createContext, useState, useEffect } from 'react';

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [permissions,setPermissions]=useState([]);
  // If UAT url changes then update UAT link in the downloadPayslip function - Endpoint is 
  // ${abstartOldUrl}pages/api/v1/new-abstart/payslip/download in PayslipSandBox.jsx
  // const [apiURL, setAPIURL] = useState('http://143.110.190.50:3189/');
  // const [apiURL, setAPIURL] = useState('https://143.110.190.50:4001/');
  // const [apiURL, setAPIURL] = useState('https://uatempapi.abstarthr.in/');
  const [apiURL, setAPIURL] = useState('https://empapi.abstarthr.in/');
  // const [apiURL, setAPIURL] = useState('http://localhost:3189/');
  // const [apiURL, setAPIURL] = useState('http://localhost:4005/');
  const [backdateRows, setBackdateRows] = useState(['2024-08-10','2024-08-15','2024-08-20',]);
  const [inductionStatus, setInductionStatus] = useState(localStorage.getItem("induction_status")|| null);
  const [token, setToken] = useState(localStorage.getItem('token_emp'));
  const [employee_id, setEmployeeId] = useState(localStorage.getItem('employee_id_emp'));
  const [company_id, setCompanyId] = useState(localStorage.getItem('company_id_emp'));
  // employee_id and company_id is replace with x-employee-id and x-company-id because in 
  // browser or backend server  is removing employee_id and company_id auto.
  const [apiHeaderJSON, setHeaderJSON] = useState({
    token: `${token}`,
    "Content-Type": "application/json",
    "x-company-id": company_id,
    "x-employee-id": employee_id,
  });
  // { 
  //   'token': `${token}`, 
  //   'Content-Type': 'application/json', 
  //   'company_id': company_id, 'employee_id': employee_id 
  // }
  const [apiHeaderFile, setHeaderFile] = useState({ 
    'token': `${token}`, 
    'Content-Type': 'multipart/form-data', 
    "x-company-id": company_id,
    "x-employee-id": employee_id,
  });

  useEffect(() => {
    
    const storedToken = localStorage.getItem('token_emp');
    if (storedToken) {
      setToken(storedToken); 
    }
  }, []); 

  const handleUpdateLogin = (data) => {
    setToken(data.token); //// Update context with new token
    localStorage.setItem('token_emp', data.token);  // Store token in local storage
    localStorage.setItem('company_id_emp', data.company_id);  // Store token in local storage
    localStorage.setItem('employee_id_emp', data.employee_id);
    localStorage.setItem('employee_code_emp', data.employee_code);
  }

  const setEmpIdState = () =>{
     setEmployeeId(localStorage.getItem('employee_id_emp',));
  }
  const setCpmIdState = () =>{
    setCompanyId(localStorage.getItem('company_id_emp',));
 }
  const placeHolderImageURL = 'http://142.93.209.237:3189/public/placeholder_category.jpeg'

  var vals = {
    apiURL, setAPIURL,
    token,
    setToken,
    handleUpdateLogin,
    placeHolderImageURL,
    apiHeaderJSON,
    apiHeaderFile,
    employee_id,
    setEmpIdState,
    company_id,
    setCpmIdState,
    backdateRows, 
    setBackdateRows,
    permissions,
    setPermissions,
    inductionStatus
  };


  return (
    <ConfigContext.Provider value={vals}>
      {children}
    </ConfigContext.Provider>
  );
};
